import React, { useState } from 'react';
import PropTypes from 'prop-types';

const AccessList = ({ title, items }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = (event) => {
    event.preventDefault();
    setExpanded(!expanded);
  };

  return (
    <div>
      <b>{title}:</b>
      {items.length === 0 ? (
        <ul><li>No {title}</li></ul>
      ) : (
        <>
          <ul>
            {items.slice(0, expanded ? items.length : 3).map((item) => (
              <li key={item.id}>{item.name}</li>
            ))}
            {items.length > 3 && (
              <li className="show-more-less-clickable" onClick={toggleExpanded}>
                {expanded ? 'less' : 'more'}
              </li>
            )}
          </ul>
        </>
      )}
    </div>
  );
};

AccessList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default AccessList;
